import { render, staticRenderFns } from "./SysInfoItem.vue?vue&type=template&id=1ed076aa&"
import script from "./SysInfoItem.vue?vue&type=script&lang=js&"
export * from "./SysInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports